(function() {
  "use strict";

  angular
    .module("app")
    .controller("CommunityDataTableController", [
      "$scope",
      CommunityDataTableController
    ]);

  function CommunityDataTableController($scope) {
    // By default, sort by the first indicator returned from the API
    // This will be "Overall Risk Ranking", if required
    $scope.sorting = {
      indicator:
        "indicators[" +
        $scope.state.selectedDomain.indicators[0].id +
        "].value",
      indicatorId: $scope.state.selectedDomain.indicators[0].id,
      reverse: false
    };

    // Middleware-ish for community data table ng-repeat
    // ng-repeat iterates through all communities, this filter checks if community is selected
    // That way, we have access to all the most recent community data without data duplication
    $scope.findSelectedCommunities = function(value, index, array) {
      if (!$scope.state.selectedCommunities) {
        return false;
      }
      return $scope.state.selectedCommunities.communityIsSelected(value.id);
    };

    $scope.sorting.sortTable = function(indicator) {
      if (indicator === $scope.sorting.indicatorId) {
        // User is re-sorting the currently selected indicator. Just flip the order.
        $scope.sorting.reverse = !$scope.sorting.reverse;
      }
      else {
        // User has selected to a new indicator. Update scope, default to top-down sorting.
        $scope.sorting.indicatorId = indicator;
        $scope.sorting.indicator = "indicators[" + indicator + "].value";
        $scope.sorting.reverse = false;
      }
    };

    $scope.isActiveSortingDirection = function(indicatorId, isReverse) {
      return (
        $scope.sorting.indicatorId === indicatorId &&
        $scope.sorting.reverse === isReverse
      );
    };

    $scope.domainHasIndicator = function(domain, indicator) {
      for (var prop in domain) {
        if (domain.hasOwnProperty(prop) && +prop === +indicator) {
          return true;
        }
      }

      return false;
    };

    // Basically, the "Overall Risk Ranking" indicator needs to render as "Overall Rank".
    // Because that indicator is arbitrary, we need to do a string match to check the indicator
    // and tweak the name if need be.
    $scope.parseIndicatorName = function(indicator) {
      return indicator === "Overall Risk Ranking" ? "Overall Rank" : indicator;
    };
  }
})();
